module.exports = __webpack_public_path__ + "img/progress_024.927acff3.png";